import { PetInterface } from 'types/pet';
import { getDisplayBreed, getFormattedCelebrationDate } from '../../../util/helpers';
import { MedicalLabels } from './../../pet-form/MedicalNew/MedicalLabels';

type DetailsField = {
  label: string;
  value: string | number | null;
};

const unknownDerivedGender = 'Unknown';

const getHealthFields = (petProfile: PetInterface): DetailsField[] => {
  const healthFields = [];
  healthFields.push(
    {
      label: 'Weight',
      value: petProfile.weightLbs ? `${petProfile.weightLbs} lbs` : null,
    },
    {
      label: 'Sex',
      value:
        petProfile.derivedGender === unknownDerivedGender
          ? null
          : petProfile.derivedGender
          ? petProfile.derivedGender
          : null,
    },
    {
      label: 'Medications',
      value: petProfile.medications.map((item) => item.name).join(', '),
    },
    {
      label: MedicalLabels.labelMedicationAllergies,
      value:
        !petProfile.medicationAllergies || petProfile.medicationAllergies.length === 0
          ? null
          : petProfile.medicationAllergies.map((item) => item.name).join(', '),
    },
    {
      label: MedicalLabels.labelMedicalConditions,
      value:
        !petProfile.medicalConditions || petProfile.medicalConditions.length === 0
          ? null
          : petProfile.medicalConditions.map((item) => item.name).join(', '),
    },
  );
  return healthFields;
};

const getBasicFields = (petProfile: PetInterface): DetailsField[] => {
  const basicFields = [];
  if (!['Cat', 'Dog', 'Horse'].includes(petProfile.petType.name)) {
    basicFields.push({
      label: `${petProfile.petType.name} Species`,
      value: petProfile.petBreedName ? petProfile.petBreedName : null,
    });
  } else {
    basicFields.push({
      label: `${petProfile.petType.name} Breed`,
      value: getDisplayBreed(petProfile, true),
    });
  }
  basicFields.push({
    label: 'Birthday',
    value: getFormattedCelebrationDate({
      celebrationDate: petProfile.birthday,
      formatTokens: 'LLL. dd, yyyy',
    }),
  });
  basicFields.push({
    label: 'Adoption Date',
    value: getFormattedCelebrationDate({
      celebrationDate: petProfile.adoptionDate,
      formatTokens: 'LLL. dd, yyyy',
    }),
  });
  return basicFields;
};

export const getMemorialDetails = (petProfile: PetInterface) => {
  const basicFields = getBasicFields(petProfile);
  const healthFields = getHealthFields(petProfile);
  return [basicFields, healthFields];
};

export const getBannerUrlWithScheme = (url?: string): string | undefined => {
  if (!!url && !/^https?:\/\//i.test(url)) {
    return 'https:' + url;
  }
  return url;
};

export const getBannerDownloadUrl = (url?: string) => url?.replace(/(_AC_SS\d+_.)/, '');

export const getAvatarDownloadUrl = (url?: string) => url?.replace(/(_SS\d+_.)/, '');
